"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _OrderedListBase = _interopRequireDefault(require("./OrderedListBase"));
var _Item = _interopRequireDefault(require("./Item"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropsTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps]);
const OrderedList = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    start = 1,
    variant = {},
    tokens = {},
    ...rest
  } = _ref;
  // Pass any variants and tokens "OrderedList" receives down to the individual list items.
  const childrenWithParentVariants = _react.default.useMemo(() => {
    const addVariantAndTokensToProps = (child, i, isLastChild) => {
      const existingChildVariants = child.props?.variant ?? {};
      const existingChildTokens = child.props?.tokens ?? {};
      return /*#__PURE__*/_react.default.cloneElement(child, {
        index: start + i,
        isLastChild,
        variant: {
          ...existingChildVariants,
          ...variant
        },
        tokens: {
          ...existingChildTokens,
          ...tokens
        }
      });
    };
    if (variant || tokens) {
      if (Array.isArray(children)) {
        return children.map((child, i) => addVariantAndTokensToProps(child, i, i === children.length - 1));
      }
      return [addVariantAndTokensToProps(children, 0, true)];
    }
    return children;
  }, [children, variant, start, tokens]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderedListBase.default, {
    ref: ref,
    ...selectProps(rest),
    children: childrenWithParentVariants
  });
});
OrderedList.propTypes = {
  ...selectedSystemPropsTypes,
  /**
   * A list of ordered items wrapped in `OrderedList.Item`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The position to start the list with.
   */
  start: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  variant: _utils.variantProp.propType,
  tokens: (0, _utils.getTokensPropType)('OrderedList')
};
OrderedList.displayName = 'OrderedList';
OrderedList.Item = _Item.default;
var _default = exports.default = OrderedList;